/*
* Pipeline Theme — custom JS
*
* BetterIMS native preorder (per-variant, stock-aware). Replaces the Timesact
* app. Driven by the `custom.preorder_ship_date` variant metafield that BetterIMS
* writes (alongside flipping inventory_policy to `continue`). The product page
* emits a per-variant map in [data-preorder-json] (see product-buttons.liquid).
*
* Hook: the theme keeps the hidden <input name="id"> in sync with the selected
* variant and dispatches a `change` event directly on it (ProductFormReader
* ._setIdInputValue in theme.js). We listen to that — the most reliable signal in
* this theme — read the selected variant id, and for that variant:
*   - show "PREORDER SHIPS <date>" under the buy button,
*   - set the button label to "Pre-order",
*   - enable the "Preorder: expected to ship <date>" line-item property,
*   - hide the in-stock/sold-out countdown.
* A variant is only treated as preorder once it is SOLD OUT (oversell via
* inventory_policy=continue); an in-stock size on a preorder PO sells normally.
*/

(function () {
  function str(key, fallback) {
    return (window.theme && theme.strings && theme.strings[key]) || fallback;
  }
  var SHIP_PREFIX = str('preorderShips', 'PREORDER SHIPS');
  var PREORDER_TEXT = str('preOrder', 'Pre-order');

  function scopeOf(el) {
    if (!el) return document;
    return (
      el.closest('[data-section-id]') ||
      el.closest('[data-quickview-modal]') ||
      document
    );
  }

  function applyPreorder(scope, variantId) {
    if (!scope) return;
    var jsonEl = scope.querySelector('[data-preorder-json]');
    if (!jsonEl) return;

    var map;
    try {
      map = JSON.parse(jsonEl.textContent || jsonEl.innerHTML);
    } catch (e) {
      return;
    }

    var idInput = scope.querySelector('[name="id"]');
    if (variantId === null || typeof variantId === 'undefined') {
      variantId = idInput ? idInput.value : null;
    }

    var entry = variantId !== null ? map[String(variantId)] : null;
    var show = !!(entry && entry.show);

    var msg = scope.querySelector('[data-preorder-ship-message]');
    var prop = scope.querySelector('[data-bims-preorder-prop]');
    var plan = scope.querySelector('[data-bims-preorder-plan]');
    var remaining = scope.querySelector('[data-remaining-wrapper]');
    var btnTexts = scope.querySelectorAll(
      '[data-buttons-wrapper] [data-add-to-cart-text]'
    );

    if (show) {
      if (msg) {
        msg.textContent = SHIP_PREFIX + (entry.label ? ' ' + entry.label : '');
        msg.classList.remove('hide');
      }
      if (prop) {
        prop.disabled = false;
        // Keep the "Preorder" line-item property's date in sync with the variant
        // so the cart/checkout reads "PREORDER expected to ship <date>".
        if (entry.label) prop.value = 'expected to ship ' + entry.label;
      }
      // Submit the BetterIMS selling plan so the order is SCHEDULED. The plan id
      // is resolved PER VARIANT server-side (product-buttons.liquid) by matching
      // the variant's own selling_plan_allocations to its shown ship date — a
      // product can carry multiple concurrent preorder groups, and submitting a
      // plan the selected variant is not a member of makes Shopify reject the
      // add ("Cannot apply selling plan to variant"). Enable only when a plan id
      // is present; otherwise leave it disabled (disabled inputs are not sent).
      if (plan) {
        if (entry.plan) {
          plan.value = entry.plan;
          plan.disabled = false;
        } else {
          plan.value = '';
          plan.disabled = true;
        }
      }
      if (remaining) remaining.classList.add('hide');
      btnTexts.forEach(function (el) {
        el.innerHTML = PREORDER_TEXT;
      });
    } else {
      if (msg) {
        msg.textContent = '';
        msg.classList.add('hide');
      }
      if (prop) prop.disabled = true;
      if (plan) {
        plan.value = '';
        plan.disabled = true;
      }
      if (remaining) remaining.classList.remove('hide');
    }
  }

  function wire(scope) {
    if (!scope) return;
    var idInput = scope.querySelector('[name="id"]');
    if (idInput && !idInput.dataset.bimsPreorderWired) {
      idInput.dataset.bimsPreorderWired = '1';
      // The theme dispatches `change` on this input whenever the variant changes.
      // We defer to the next tick so our update runs AFTER the theme's own button
      // refresh (which would otherwise overwrite our "Pre-order" label).
      idInput.addEventListener('change', function () {
        setTimeout(function () {
          applyPreorder(scope, idInput.value);
        }, 0);
      });
    }
    applyPreorder(scope, null);
  }

  function initAll() {
    document.querySelectorAll('[data-preorder-json]').forEach(function (jsonEl) {
      wire(scopeOf(jsonEl));
    });
  }

  // Bonus: also honor the theme's custom event if/when it fires.
  document.addEventListener('theme:variant:change', function (event) {
    var v = event.detail && event.detail.variant;
    applyPreorder(scopeOf(event.target), v ? v.id : null);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
